import React from 'react'
import Wrapper from '../Wrapper'

const Profile = () => {
  return (
    <Wrapper>
        Profile
    </Wrapper>
  )
}

export default Profile